import { eventCategory } from '../constants/gameEvents';
import { convertStaticPriceAmountToMajorUnits } from '../utils/price';
import { getUserSuid } from '../general/modules/getUserSuid';
import { TaxLoader } from '../general/modules/Taxes/TaxLoader/TaxLoader';
import { FeeService } from '../general/modules/Taxes/Fee/FeeService';
import { LocalStorageCache } from '../cache/localStorageCache';
import { VatService } from '../general/modules/Taxes/VAT/VatService';
import { ITaxUserData, TaxesCalculator } from '../general/modules/Taxes/TaxesCalculator';


export class GtmSender {
    public static dataLayer = window.dataLayer || [];

    public static fireMarketing(eventName: string, customFields?: object): void {
        const eventData = {
            event: eventName,
            eventCategory: eventCategory.MARKETING
        };
        this.dataLayer.push({...eventData, ...customFields});
    }

    public static firePrereg(eventName: string): void {
        this.dataLayer.push({
            event: eventName,
            eventCategory: eventCategory.PREREG
        });
    }

    public static fireWebgl(eventName: string): void {
        this.dataLayer.push({
            event: eventName,
            eventCategory: eventCategory.WEBGL_CLIENT_EVENTS
        });
    }

    public static fireClient(eventName: string): void {
        this.dataLayer.push({
            event: eventName,
            eventCategory: this.getClientEventsCategory()
        });
    }

    public static fireWipe(eventName: string): void {
        this.dataLayer.push({
            event: eventName,
            eventCategory: eventCategory.WIPE
        });
    }

    public static fireLanding(eventName: string): void {
        this.dataLayer.push({
            event: eventName,
            eventCategory: eventCategory.LANDING
        });
    }

    public static fireIndex(eventName: string): void {
        this.dataLayer.push({
            event: eventName,
            eventCategory: eventCategory.INDEX
        });
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public static async fireFacebook(eventName: string, data: any) {
        const majorPrice = convertStaticPriceAmountToMajorUnits(data.paymentObject.price);
        const revenue = await this.calculateClearRevenue(majorPrice);
        this.dataLayer.push({
            event: eventName,
            FBContentName: encodeURIComponent(data.paymentObject.name || 'N/A'),
            paymentCurrency: data.paymentObject.currency,
            paymentValue: revenue,
            paymentID: data.paymentObject.id,
            paymentGuid: window.app.config.stringGuid
        });
    }

    public static async fireEcommerce(eventName: string, revenue: number) {
        const suid = getUserSuid();
        const clearRevenue = await this.calculateClearRevenue(revenue);
        this.dataLayer.push({
            ecommerce: {
                currencyCode: 'USD',
                purchase: {
                    actionField: {
                        id: Date.now() + suid,
                        revenue: clearRevenue,
                        tax: '',
                        shipping: '',
                        coupon: ''
                    }
                }
            },
            event: eventName,
            eventCategory: 'ecommerce'
        });
    }

    public static getClientEventsCategory(): string {
        return eventCategory.WEBGL_CLIENT_EVENTS;
    }

    public static fireCommonEvent(eventName: string, eventType: string): void {
        this.dataLayer.push({
            event: eventName,
            eventCategory: eventType
        });
    }


    public static async calculateClearRevenue(revenue: number): Promise<number> {
        const taxLoader = new TaxLoader();
        const feeService = new FeeService(new LocalStorageCache(), taxLoader);
        const vatService = new VatService(new LocalStorageCache(), taxLoader);
        const userData: ITaxUserData = {
            country: window.app.config.country,
            paymentMethod: window.app.lastPaymentMethod.toString()
        };
        const taxFacade = new TaxesCalculator(feeService, vatService, userData);
        const clearRevenue = await taxFacade.calculate(revenue);

        return clearRevenue;
    }
}
